import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import { actions } from "../../../../Redux";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import DatePicker from "react-datepicker";
import moment from "moment";
import { objToArr } from "../../../../helpers";
const Expenses = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const expensesData = useSelector(
    (state) => state?.financeReducer?.expensesData
  );

  console.log(expensesData, "ppppppp");

  const [timeLimit, setTimeLimit] = useState("month");
  const [calDate, setCalDate] = useState(null);
  useEffect(() => {
    dispatch(
      actions?.getExpensesData({
        timeLimit: timeLimit,
        dateStart: moment(new Date()).format("YYYY-MM-DD"),
      })
    );
  }, [timeLimit]);

  const startDate = moment(expensesData?.return?.prevDate).format(
    "MMM DD, YYYY"
  );
  const endDate = moment(expensesData?.return?.limitDate).format(
    "MMM DD, YYYY"
  );
  const todaysDate = moment(new Date()).format("MMM DD, YYYY");

  function getDaysInMonth(month) {
    return new Date(2000, month, 0).getDate();
  }

  function handleLeftClick() {
    // getting prev date
    let year =
      timeLimit === "year"
        ? new Date(startDate).getFullYear() - 1
        : new Date(startDate).getFullYear();
    let month = (() => {
      let monthNumber = new Date(startDate).getMonth() + 1;
      if (timeLimit === "month") {
        if (monthNumber == 1) {
          year--;
          return 12;
        } else {
          return monthNumber - 1;
        }
      } else if (timeLimit === "quarter") {
        if (monthNumber == 3) {
          year--;
          return 12;
        } else if (monthNumber > 3) {
          return monthNumber - 3;
        } else {
          year--;
          return 12 - Math.abs(monthNumber - 3);
        }
      } else return monthNumber;
    })();

    let day = (() => {
      let dayNumber = new Date(startDate)?.getDate();
      if (timeLimit === "week") {
        if (dayNumber - 7 > 0) return dayNumber - 7;
        else {
          month = month - 1;
          return getDaysInMonth(month) - Math.abs(dayNumber - 7);
        }
      } else if (timeLimit === "day") {
        if (dayNumber - 1 > 0) return dayNumber - 1;
        else {
          month = month - 1;
          return getDaysInMonth(month) - 1;
        }
      } else return dayNumber;
    })();
    console.log("aaaaa", month);
    dispatch(
      actions?.getExpensesData({
        timeLimit: timeLimit,
        dateStart: `${year}-${month}-${day}`,
      })
    );
  }
  function handleRightClick() {
    // getting prev date
    let year =
      timeLimit === "year"
        ? new Date(startDate).getFullYear() + 1
        : new Date(startDate).getFullYear();
    let month = (() => {
      let monthNumber = new Date(startDate).getMonth() + 1;
      if (timeLimit === "month") {
        if (monthNumber == 12) {
          year++;
          return 1;
        } else {
          return monthNumber + 1;
        }
      } else if (timeLimit === "quarter") {
        if (monthNumber == 12) {
          year++;
          return 1;
        } else if (monthNumber < 9) {
          return monthNumber + 3;
        } else {
          year++;
          return (monthNumber + 3) % 12;
        }
      } else return monthNumber;
    })();

    let day = (() => {
      let dayNumber = new Date(startDate)?.getDate();
      let daysInMonth = getDaysInMonth(month);
      if (timeLimit === "week") {
        if (dayNumber + 7 > daysInMonth) {
          month = month + 1;
          return Math.abs(7 - (daysInMonth - dayNumber));
        } else {
          return dayNumber + 7;
        }
      } else if (timeLimit === "day") {
        if (dayNumber + 1 > daysInMonth) {
          month++;
          return 1;
        } else {
          return dayNumber + 1;
        }
      } else return dayNumber;
    })();
    console.log("aaaaa", month);
    dispatch(
      actions?.getExpensesData({
        timeLimit: timeLimit,
        dateStart: `${year}-${month}-${day}`,
      })
    );
  }
  function getSubAccount(rowEl) {
    if (rowEl?.type == 4) return "Payroll";
    else if (rowEl?.type == 13) return "Income Tax Authority";
    else return rowEl?.debit_account?.name;
  }
  console.log(expensesData, "pppppppp");
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />{" "}
        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="row mx-0">
              <div className="container px-0">
                <div className="row">
                  <div class="col-md-12">
                    <div className="shadowclass mt-3">
                      <div class="inventory_summary_master">
                        <div class="row-fluid">
                          <div class="col-12">
                            <div class="counts date_new_Cont">
                              <h4 class="event-alert">Select Your Period</h4>

                              <div class="half_new_div d-flex sm-calander">
                                <a
                                  onClick={handleLeftClick}
                                  href="#_"
                                  class="date_label"
                                >
                                  <i class="iconSprites arrow-left"></i>
                                </a>
                                <span class="date-text">
                                  {startDate} - {endDate}
                                </span>
                                <a
                                  onClick={handleRightClick}
                                  href="#_"
                                  class={`date_label ${
                                    endDate == todaysDate ? "hide_div" : ""
                                  }`}
                                >
                                  <i class="iconSprites arrow-right"></i>
                                </a>
                                <span class="clander_icon"></span>
                                <DatePicker
                                  selected={calDate}
                                  onChange={(date) => {
                                    setCalDate(date);
                                    dispatch(
                                      actions?.getExpensesData({
                                        timeLimit: timeLimit,
                                        dateStart:
                                          moment(date).format("YYYY-MM-DD"),
                                      })
                                    );
                                  }}
                                />
                              </div>

                              <div class="half_right_div">
                                <ul class="summary_filter add">
                                  <li
                                    onClick={() => setTimeLimit("day")}
                                    class={`${
                                      timeLimit === "day" ? "active" : ""
                                    }`}
                                  >
                                    <a>Day</a>{" "}
                                  </li>
                                  <li
                                    onClick={() => setTimeLimit("week")}
                                    class={`${
                                      timeLimit === "week" ? "active" : ""
                                    }`}
                                  >
                                    <a>Week</a>{" "}
                                  </li>
                                  <li
                                    onClick={() => setTimeLimit("month")}
                                    class={`${
                                      timeLimit === "month" ? "active" : ""
                                    }`}
                                  >
                                    <a>Month</a>{" "}
                                  </li>
                                  <li
                                    onClick={() => setTimeLimit("quarter")}
                                    class={`${
                                      timeLimit === "quarter" ? "active" : ""
                                    }`}
                                  >
                                    <a>Quarter</a>{" "}
                                  </li>
                                  <li
                                    onClick={() => setTimeLimit("year")}
                                    class={`${
                                      timeLimit === "year" ? "active" : ""
                                    }`}
                                  >
                                    <a>Year</a>{" "}
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row-fluid mt-3">
                  <div class="span12 text-right">
                    <a class="btn green-btn-revert add-plus">Add AP Invoice</a>
                    <button
                      class="btn green-btn-revert add-plus"
                      type="button"
                      onclick="location.href='/payments/add_payment'"
                    >
                      <i class="i-icon"> </i> Add Quick Pay
                    </button>
                  </div>
                </div>

                {objToArr(expensesData?.transactions)?.map((tableEl, idx) => {
                  console.log(tableEl, "tableEl");
                  return (
                    <div className="accordion-item">
                      <h2
                        className="accordion-header"
                        id="panelsStayOpen-headingNine2"
                      >
                        <button
                          className="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#accordion-toggle-${idx}`}
                          aria-expanded="true"
                          aria-controls={`accordion-toggle-${idx}`}
                        >
                          <div className="col d-flex align-items-center justify-content-between">
                            <h4 className="event-alert p-0 mb-0">
                              {tableEl?.value}
                            </h4>
                          </div>
                        </button>
                      </h2>

                      <div
                        id={`accordion-toggle-${idx}`}
                        className="accordion-collapse collapse show"
                        aria-labelledby="panelsStayOpen-headingNine2"
                      >
                        <div className="row mx-0 pendingShiftMs">
                          <div className="container px-0">
                            <div className="shadowclass mt-0">
                              <div className="row justify-content-between align-items-center mx-0">
                                <div className="col-lg-4 col-md-5 px-0 mb-3 mb-sm-0"></div>
                              </div>

                              <div className="table-responsive">
                                <table className="checklist-table remove-space ingredTable">
                                  <thead>
                                    <tr>
                                      {expensesData?.isShowLinkedData && (
                                        <th>Account</th>
                                      )}
                                      <th className="">Transaction Date</th>
                                      <th className="">
                                        {tableEl?.label?.view?.title} Account
                                      </th>
                                      <th className="">Sub-Account</th>
                                      <th className="">Description</th>
                                      <th className="">Amount</th>
                                      <th className="">
                                        {" "}
                                        {tableEl?.label?.type === 5
                                          ? "Opposing Account"
                                          : "Payment Account"}{" "}
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {tableEl?.label?.transactions?.map(
                                      (rowEl) => (
                                        <tr>
                                          {expensesData?.isShowLinkedData && (
                                            <td className="">
                                              {rowEl?.merchant?.account_name}
                                            </td>
                                          )}
                                          <td className="">
                                            {rowEl?.transaction_date}
                                          </td>
                                          <td className="">
                                            {rowEl?.debit_account?.parent?.name}
                                          </td>
                                          <td className="">
                                            {getSubAccount(rowEl)}
                                          </td>
                                          <td className="">
                                            {rowEl?.description}
                                          </td>
                                          <td className="">
                                            {rowEl?.transaction_amount}
                                          </td>
                                          <td className="">
                                            {rowEl?.credit_account2?.name}
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default Expenses;
